import * as React from 'react';
import classnames from 'classnames';
import isNil from 'lodash/isNil';

import './profile-card.scss';

interface Props {
  title?: {
    text: string,
    popover?: React.ReactNode
  },
  subtitle?: {
    text: string
  },
  children: React.ReactNode,
  borderRadius?: number,
  withBoxShadow?: boolean,
  className?: string,
  classNameContents?: string
}

const ProfileCard: React.FC<Props> = ({
  title,
  subtitle,
  children,
  borderRadius,
  withBoxShadow,
  className,
  classNameContents
}): JSX.Element => {
  const renderTitlePopover = (): React.ReactNode => (
    <div className="profile-card__title-popover">
      {title?.popover}
    </div>
  );

  const renderTitle = (): React.ReactNode => (
    <div className="profile-card__title">
      {title?.text}
      {!isNil(title?.popover) && renderTitlePopover()}
    </div>
  );

  const renderSubtitle = (): React.ReactNode => (
    <div className="profile-card__subtitle">
      {subtitle?.text}
    </div>
  );

  const renderContents = (): React.ReactNode => {
    const contentClasses = classnames('profile-card__contents', classNameContents, {
      'profile-card__contents--with-title': Boolean(title?.text || subtitle?.text)
    });

    return (
      <div className={contentClasses}>
        {children}
      </div>
    );
  };

  const styles = {} as React.CSSProperties;

  if (borderRadius) {
    styles.borderRadius = borderRadius;
  }

  const containerClasses = classnames('profile-card', className, {
    'profile-card--box-shadow': Boolean(withBoxShadow)
  });

  return (
    <div
      className={containerClasses}
      style={{ ...styles }}
    >
      {title && renderTitle()}
      {subtitle && renderSubtitle()}
      {children && renderContents()}
    </div>
  );
};

export default ProfileCard;
